// extracted by mini-css-extract-plugin
export default {"title":"order-details_dialog_title__zMMZ0","h1":"order-details_dialog_h1__kDQwQ"};